import Keycloak, { KeycloakConfig } from 'keycloak-js'

import { env } from '@/env'

const {
  REACT_APP_SUBDOMAIN,
  REACT_APP_KEYCLOAK_SUBDOMAIN,
  REACT_APP_KEYCLOAK_PATHNAME,
  REACT_APP_KEYCLOAK_CUSTOM_URL,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENTID,
} = env

if (REACT_APP_KEYCLOAK_REALM === undefined) {
  throw new Error('Missing key REACT_APP_KEYCLOAK_REALM in .env')
}

if (REACT_APP_KEYCLOAK_CLIENTID === undefined) {
  throw new Error('Missing key REACT_APP_KEYCLOAK_CLIENTID in .env')
}

// Remove -lms suffix from domain when user is connecting to Masterplan through SCORM package
// and remove web app subdomain, if present.
const host = window.location.host
  .replace(/-lms\.com$/, '.com')
  .replace(new RegExp(`^${REACT_APP_SUBDOMAIN}\\.`), '')
const url =
  REACT_APP_KEYCLOAK_CUSTOM_URL ||
  `${window.location.protocol}//${REACT_APP_KEYCLOAK_SUBDOMAIN}.${host}${REACT_APP_KEYCLOAK_PATHNAME}`

export const authConfig: KeycloakConfig = {
  url,
  realm: REACT_APP_KEYCLOAK_REALM,
  clientId: REACT_APP_KEYCLOAK_CLIENTID,
}

const keycloak = Keycloak(authConfig)

export default keycloak
